import type { RouterConfig } from '@nuxt/schema';

export default {
  scrollBehavior(to, from) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }

    if (!from.name) {
      return;
    }
  },
  routes: (_routes) => [
    ..._routes,
    {
      name: 'main',
      path: '/',
      component: () => import('@/pages/main/Main.vue'),
      children: [
        {
          name: 'films',
          path: '/films',
          component: () => import('@/pages/kino/Films.vue'),
          meta: {
            isModalPage: true,
          },
        },
        {
          name: 'film',
          path: '/films/:id',
          component: () => import('@/pages/kino/Film.vue'),
          meta: {
            isModalPage: true,
          },
        },
        {
          name: 'announces',
          path: '/announces',
          component: () => import('@/pages/kino/Announces.vue'),
          meta: {
            isModalPage: true,
          },
        },
        {
          name: 'announce',
          path: '/announces/:id',
          component: () => import('@/pages/kino/Announce.vue'),
          meta: {
            isModalPage: true,
          },
        },
        {
          name: 'schedule',
          path: '/schedules/:id',
          component: () => import('@/pages/kino/Schedule.vue'),
          meta: {
            isModalPage: true,
          },
        },
      ],
    },

    {
      name: 'auth',
      path: '/auth',
      component: () => import('@/pages/auth/Auth.vue'),
    },

    {
      path: '/domains',
      name: 'domains',
      component: () => import('@/pages/domains/Domains.vue'),
    },

    {
      path: '/articles',
      component: () => import('@/widgets/article/ui/ArticleLayout.vue'),
      children: [
        {
          path: '',
          name: 'articles',
          component: () => import('@/pages/article/List.vue'),
        },
        {
          path: 'categories-manage',
          name: 'articles-categories-manage',
          component: () => import('@/pages/article/CategoriesManage.vue'),
        },
        {
          path: ':id',
          name: 'articles-show',
          component: () => import('@/pages/article/Item.vue'),
        },
        {
          path: ':id/edit',
          name: 'articles-edit',
          component: () => import('@/pages/article/Edit.vue'),
        },
        {
          path: 'new',
          name: 'articles-create',
          component: () => import('@/pages/article/Create.vue'),
        },
      ],
    },

    {
      path: '/news',
      component: () => import('@/widgets/article/ui/ArticleLayout.vue'),
      children: [
        {
          path: '',
          name: 'news',
          component: () => import('@/pages/news/List.vue'),
        },
        {
          path: 'categories-manage',
          name: 'news-categories-manage',
          component: () => import('@/pages/news/CategoriesManage.vue'),
        },
        {
          path: ':id',
          name: 'news-show',
          component: () => import('@/pages/news/Item.vue'),
        },
        {
          path: ':id/edit',
          name: 'news-edit',
          component: () => import('@/pages/news/Edit.vue'),
        },
        {
          path: 'new',
          name: 'news-create',
          component: () => import('@/pages/news/Create.vue'),
        },
      ],
    },

    {
      name: 'custom-pages-edit',
      path: '/p/:firstLevelPageSlug/edit',
      component: () => import('@/pages/custom-page/CustomPageEdit.vue'),
      meta: {
        layout: 'edit-page',
      },
    },
    {
      name: 'custom-pages',
      path: '/p/:firstLevelPageSlug/:secondLevelPageSlug?/:thirdLevelPageSlug?/:fourthLevelPageSlug?',
      component: () => import('@/pages/custom-page/CustomPage.vue'),
    },

    {
      path: '/unavailable',
      name: 'company-status',
      component: () => import('@/pages/errors/CompanyStatus.vue'),
      meta: {
        layout: false,
      },
    },
  ],
} satisfies RouterConfig;
